import { createDeviceTelemetrySaga } from '../Telemetry/deviceTelemetrySagas';
import { DeviceTelemetryType } from '@signageos/common-types/dist/Device/Telemetry/DeviceTelemetryType';
import IGetTelemetryProperties from '../Telemetry/IGetTelemetryProperties';
import { MonitoringLogData } from '@signageos/common-types/dist/Device/MonitoringLog/MonitoringLogData';
import ManagementCapability from '../../../NativeDevice/Management/ManagementCapability';
import Responsibility from '../../../Feature/Responsibility';
import { withDependencies } from '../../../DI/dependencyInjection';
import { IResponsibilities } from '../../../Feature/Responsibilities';
import IManagementDriver from '../../../NativeDevice/Management/IManagementDriver';
import { IPropertyStorage } from '../../../Property/propertyStorage';
import { IProprietaryTimerStorage } from '../../../Timer/ITimerStorage';
import { PowerActionRules } from '../../../NativeDevice/Power/IPowerActionTimer';
import { call } from 'redux-saga/effects';

const baseTelemetrySaga = createDeviceTelemetrySaga(
	DeviceTelemetryType.MEMORY_USAGE,
	Responsibility.TELEMETRY,
	[ManagementCapability.SYSTEM_MEMORY],
	getMemoryUsageSettings,
);

// Create saga that checks feature flags before creating Memory telemetry
const memoryTelemetryWithFeatureFlag = withDependencies(
	['featureFlags'],
	function* (
		{ featureFlags },
		responsibilities: IResponsibilities,
		getManagementDriver: () => IManagementDriver,
		propertyStorage: IPropertyStorage,
		timerStorage: IProprietaryTimerStorage,
		powerActionRules: () => Promise<PowerActionRules>,
		applicationVersion: string,
	) {
		// Check if Memory usage telemetry is enabled (default to false to match config)
		if (!(featureFlags?.memoryUsage ?? false)) {
			return;
		}
		// Create and yield the standard telemetry saga
		const telemetrySaga = baseTelemetrySaga(
			responsibilities,
			getManagementDriver,
			propertyStorage,
			timerStorage,
			powerActionRules,
			applicationVersion,
		);
		yield telemetrySaga;
	},
);

// Export wrapper function that properly calls the withDependencies saga
export function* telemetryMemoryUsageSettingsSaga(
	responsibilities: IResponsibilities,
	getManagementDriver: () => IManagementDriver,
	propertyStorage: IPropertyStorage,
	timerStorage: IProprietaryTimerStorage,
	powerActionRules: () => Promise<PowerActionRules>,
	applicationVersion: string,
) {
	// Actually call the withDependencies saga with parameters
	yield call(
		memoryTelemetryWithFeatureFlag,
		responsibilities,
		getManagementDriver,
		propertyStorage,
		timerStorage,
		powerActionRules,
		applicationVersion,
	);
}

export async function getMemoryUsageSettings({
	managementDriver,
}: IGetTelemetryProperties): Promise<MonitoringLogData[DeviceTelemetryType.MEMORY_USAGE]> {
	try {
		const memoryData = await managementDriver.systemInfo.getMemoryUsage();
		return memoryData;
	} catch (error) {
		throw error;
	}
}
